import BeautyFilterBridge from './beautyFilterBridge';
import BottomSheetBridge from './bottomSheetBridge';
import DialogBridge from './dialogBridge';
import ToastBridge from './toastBridge';
import UnderagePageBridge from './underageBridge';

const BRIDGES = {
  BeautyFilterBridge: BeautyFilterBridge,
  BottomSheetBridge: BottomSheetBridge,
  DialogBridge: DialogBridge,
  ToastBridge: ToastBridge,
  UnderagePageBridge: UnderagePageBridge,
};

export default BRIDGES;
